module.exports = __webpack_public_path__ + "static/media/03_plantilla_combo_rectangular_logo_cc_blanco.6d4d48cd.png";